// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1DJnJ","rootSmall":"AddTileButton_rootSmall__2ibHy"};